import  {GET_LIST_OF_COLUMNS} from "../constants/actionTypes";
import * as api from "../api/index.js";

// actions/listOfColumns.js
export const getListOfColumns = (formData) => async (dispatch) => {
  try {
    const response = await api.getListOfColumns(formData);
    dispatch({
      type: GET_LIST_OF_COLUMNS,
      payload: response.data,
    });
    return response.data; // ✅ return the actual data
  } catch (error) {
    console.error("GET_LIST_OF_COLUMNS error", error);
    throw error;
  }
};
